/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Odd_Orangutan_AscendInputs */

const fr_free_odd_orangutan_ascend = /** @type {(inputs: Free_Odd_Orangutan_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visites`)
};

/**

* @param {Free_Odd_Orangutan_AscendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_odd_orangutan_ascend = /** @type {((inputs?: Free_Odd_Orangutan_AscendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Odd_Orangutan_AscendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_odd_orangutan_ascend(inputs)
});